import { resolveBrandColorFromSettings } from 'frontend/features/branding/resolveBrandColorFromSettings';
import { selectBrandingSettings } from 'legacyfrontend/redux/selectors/branding-selectors';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

/** Applies Personalizar primary color to legacy listing CSS variables (`--mbr-background`). */
const ListingBrandScope = ({ children, className = '' }) => {
  const brandingSettings = useSelector(selectBrandingSettings);
  const brandColor = resolveBrandColorFromSettings(brandingSettings);
  const style = brandColor ? { '--mbr-background': brandColor } : undefined;

  useEffect(() => {
    if (!brandColor || typeof document === 'undefined') {
      return undefined;
    }

    const root = document.documentElement;
    const previous = root.style.getPropertyValue('--mbr-background');
    root.style.setProperty('--mbr-background', brandColor);

    return () => {
      if (previous) {
        root.style.setProperty('--mbr-background', previous);
      } else {
        root.style.removeProperty('--mbr-background');
      }
    };
  }, [brandColor]);

  return (
    <div className={className} style={style}>
      {children}
    </div>
  );
};

export default ListingBrandScope;
